module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "part1"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#p01"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "part2",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#p01x"
    }
  }, [_vm._v("ANGIE AND BARRY")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "block2"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('strong', [_vm._v("From:")]), _vm._v(" Angela Finnegan "), _c('a', {
    attrs: {
      "href": "mailto:angiebaz@demon.co.uk"
    }
  }, [_vm._v("angiebaz@demon.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("Date:")]), _vm._v(" 16 May 17:31:01 BST")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("To:")]), _vm._v(" Susan Dunning "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "mailto:susan.dunning1@gmail.com"
    }
  }, [_vm._v("susan.dunning1@gmail.com")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("Cc:")]), _vm._v(" Marina Green "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "mailto:marinagreen1979@btinternet.com"
    }
  }, [_vm._v("marinagreen1979@btinternet.com")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("Subject:")]), _vm._v(" Dinner!!!")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Hi All!")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("You know how you meet people on holiday and say things like ‘we really must stay in touch’? I bet you’re regretting swapping those email addresses now. Ha ha!")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Seriously though, it was an amazing holiday even if it did end a bit oddly, so I thought it would be great if we could all get together. So, me and Barry would love it if the four of you could come to dinner on Saturday, June 4th. I know it’s a bit of a trek down here to deepest, darkest Crawley but I do a mean bread and butter pud and I promise to send out sherpas if you get lost!!")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Talk to the boys and let me know ASAP, but I really hope you can all make it.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Lotsa love,"), _c('br'), _vm._v("Angie xxx")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("PS. Been looking at the local papers on the internet and still no sign of that poor girl. Can’t imagine what her mother must be going through. Horrible, just horrible.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("PPS. Can’t remember, but is anyone a veggie?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd768e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/p01.vue
// module id = 81
// module chunks = 0